module.exports = __webpack_public_path__ + "static/media/icon_39.c1ade1a2.svg";